module.exports = __webpack_public_path__ + "img/图层871@2x.0bc8d5f0.png";